import React from 'react'
import { Row, Col, Button, Card, CardBody, CardFooter, CardImg } from 'reactstrap'
import Page from 'ui/page'
import ourStory from 'goforajourney/img/our-story'
import goforajourneyLogo from 'goforajourney/img/goforajourney-logo-h'
import marrakechCardImage from 'goforajourney/img/marrakech-card-h.webp'
import italyCardImage from 'goforajourney/img/italy-card.webp'
import franceCardImage from 'goforajourney/img/france-card.webp'
import mexicoCardImage from 'goforajourney/img/mexico-card-h.webp'
import spainCardImage from 'goforajourney/img/spain-card.webp'

const redirectToProduct = (product_url) => {
  window.location.href = product_url
}

const Goforasketch = (props) => {
  const {client_params, products} = props
  const {contact_email} = client_params

  return (
    <Page {...props}>
      <div className="my-5" style={{fontSize: '1.2em'}}>
        <h1 className="mb-3 fw-bold text-center">Travel with intention • Create with passion</h1>

        <div className="h2 text-center fw-bold mb-5">gofora<span className="text-primary">sketch</span></div>

        <p className="text-center mb-5">We design artist-led, multi-day workshops that connect you <br/> with the world of traveling through creativity, culture, and passion</p>

        <Row className="my-5 align-items-stretch">
          <Col xs="12" md="5" className="offset-md-1 d-flex mb-5 mb-md-0" style={{cursor: 'pointer'}} onClick={() => redirectToProduct(products.mexico)}>
            <div className="px-3 px-md-5 d-flex flex-column w-100 h-100">
              <div className="position-relative">
                <div
                  className="position-absolute text-white fw-bold"
                  style={{
                    top: '0.75em',
                    left: '1em',
                    fontSize: 'clamp(1rem, 2vw, 1.8rem)',
                    textShadow: '1px 1px 3px #000',
                    zIndex: 2,
                  }}
                >
                  September
                </div>

                <div
                  className="position-absolute text-white fw-bold d-flex justify-content-center align-items-center"
                  style={{
                    inset: 0,
                    fontSize: 'clamp(2rem, 4vw, 3rem)',
                    textShadow: '1px 1px 3px #000',
                    zIndex: 2,
                  }}
                >
                  Mexico
                </div>

                <img
                  className="rounded-5 mb-3"
                  alt="Goforajourney Our Story"
                  src={mexicoCardImage}
                  style={{
                    width: '100%',
                    height: 'clamp(220px, 35vw, 300px)',
                    objectFit: 'cover',
                  }}
                />
              </div>

              <div className="rounded-5 border mt-2 mt-md-3 px-4 px-md-5 py-3 flex-grow-1 d-flex justify-content-center align-items-center text-center">
                <div>
                  Journey through the beauty of
                  <strong className="ms-2 text-primary">Mexico City</strong> and{' '}
                  <strong className="text-primary">Oaxaca</strong>, discovering the wonders of
                  pre-Columbian art, murals, <strong className="text-primary">Frida Kahlo</strong>,{' '}
                  <strong className="text-primary">Diego Rivera</strong>, and more.
                </div>
              </div>

            </div>
          </Col>

          <Col xs="12" md="5" className="d-flex" style={{cursor: 'pointer'}} onClick={() => redirectToProduct(products.spain)}>
            <div className="px-3 px-md-5 d-flex flex-column w-100 h-100">
              <div className="position-relative">
                <div
                  className="position-absolute text-white fw-bold"
                  style={{
                    top: '0.75em',
                    left: '1em',
                    fontSize: 'clamp(1rem, 2vw, 1.8rem)',
                    textShadow: '1px 1px 3px #000',
                    zIndex: 2,
                  }}
                >
                  October
                </div>

                <div
                  className="position-absolute text-white fw-bold d-flex justify-content-center align-items-center"
                  style={{
                    inset: 0,
                    fontSize: 'clamp(2rem, 4vw, 3rem)',
                    textShadow: '1px 1px 3px #000',
                    zIndex: 2,
                  }}
                >
                  Spain
                </div>

                <img
                  className="rounded-5 mb-3"
                  alt="Goforajourney Our Story"
                  src={spainCardImage}
                  style={{
                    width: '100%',
                    height: 'clamp(220px, 35vw, 300px)',
                    objectFit: 'cover',
                  }}
                />
              </div>

              <div className="rounded-5 border mt-2 mt-md-3 px-4 px-md-5 py-3 flex-grow-1 d-flex justify-content-center align-items-center text-center">
                <div>
                  Take a journey with us through the beautiful landscapes of Catalonia,
                  exploring the streets and architecture of{' '}
                  <strong className="text-primary">Barcelona</strong>. Admire and sketch{' '}
                  <strong className="text-primary">Costa Brava</strong>,{' '}
                  <strong className="text-primary">Sitges</strong>,{' '}
                  <strong className="text-primary">Girona</strong>, the Empúries, and the
                  iconic works of <strong className="text-primary">Gaudí</strong> and{' '}
                  <strong className="text-primary">Dalí</strong>.
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="my-5">
          <Col xs="12" className="text-center">
            <h2 className=" fw-bold my-5">What is gofora<span className="text-primary">journey</span>?</h2>
            <p>
              <strong>Gofora<span className="text-primary">journey</span></strong> connects travelers to curated, intimate, cultural <br/>
              experiences that leaves lasting, beautiful memories to hold onto forever. <br/>
              See the world through the eyes of those who call it home.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs="12" className="text-center my-5">
            <h2 className=" fw-bold mb-5">2027 locations coming soon...</h2>

            <Row>
              {/* MARRAKECH */}
              <Col xs="12" md="4" className="d-flex mb-5 mb-md-0">
                <div className="px-3 px-md-5 d-flex flex-column w-100">
                  <div className="position-relative">
                    <div
                      className="position-absolute text-white fw-bold"
                      style={{
                        top: '0.75em',
                        left: '1em',
                        fontSize: 'clamp(1rem, 2vw, 1.5rem)',
                        textShadow: '1px 1px 3px #000',
                        zIndex: 2,
                      }}
                    >
                      Early 2027
                    </div>

                    <div
                      className="position-absolute text-white fw-bold d-flex justify-content-center align-items-center"
                      style={{
                        inset: 0,
                        fontSize: 'clamp(1.8rem, 3.5vw, 2.5rem)',
                        textShadow: '1px 1px 3px #000',
                        zIndex: 2,
                      }}
                    >
                      Marrakech
                    </div>

                    <img
                      className="rounded-5 mb-3"
                      alt="Marrakech"
                      src={marrakechCardImage}
                      style={{
                        width: '100%',
                        height: 'clamp(220px, 30vw, 280px)',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                </div>
              </Col>

              {/* ITALIA */}
              <Col xs="12" md="4" className="d-flex mb-5 mb-md-0">
                <div className="px-3 px-md-5 d-flex flex-column w-100">
                  <div className="position-relative">

                    <div
                      className="position-absolute text-white fw-bold"
                      style={{
                        top: '0.75em',
                        left: '1em',
                        fontSize: 'clamp(1rem, 2vw, 1.5rem)',
                        textShadow: '1px 1px 3px #000',
                        zIndex: 2,
                      }}
                    >
                      Mid 2027
                    </div>

                    <div
                      className="position-absolute text-white fw-bold d-flex justify-content-center align-items-center"
                      style={{
                        inset: 0,
                        fontSize: 'clamp(1.8rem, 3.5vw, 2.5rem)',
                        textShadow: '1px 1px 3px #000',
                        zIndex: 2,
                      }}
                    >
                      Italy
                    </div>

                    <img
                      className="rounded-5 mb-3"
                      alt="Italy"
                      src={italyCardImage}
                      style={{
                        width: '100%',
                        height: 'clamp(220px, 30vw, 280px)',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                </div>
              </Col>

              {/* FRANCE */}
              <Col xs="12" md="4" className="d-flex mb-5 mb-md-0">
                <div className="px-3 px-md-5 d-flex flex-column w-100">
                  <div className="position-relative">

                    <div
                      className="position-absolute text-white fw-bold"
                      style={{
                        top: '0.75em',
                        left: '1em',
                        fontSize: 'clamp(1rem, 2vw, 1.5rem)',
                        textShadow: '1px 1px 3px #000',
                        zIndex: 2,
                      }}
                    >
                      Mid 2027
                    </div>

                    <div
                      className="position-absolute text-white fw-bold d-flex justify-content-center align-items-center"
                      style={{
                        inset: 0,
                        fontSize: 'clamp(1.8rem, 3.5vw, 2.5rem)',
                        textShadow: '1px 1px 3px #000',
                        zIndex: 2,
                      }}
                    >
                      France
                    </div>

                    <img
                      className="rounded-5 mb-3"
                      alt="France"
                      src={franceCardImage}
                      style={{
                        width: '100%',
                        height: 'clamp(220px, 30vw, 280px)',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="text-center">
              For more information about our itineraries, email us <a href={`mailto:${contact_email}`}>{contact_email}</a>
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <img src={goforajourneyLogo} alt="Goforajourney Logo" className="text-center"/>
          </Col>
        </Row>
      </div>
    </Page>
  )
}

export default Goforasketch
